import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

// Values mirror the API's ContentPlanOutputMix enum exactly - they go over the wire as-is.
export type ContentPlanOutputMix = 'EmailAndSocial' | 'EmailOnly' | 'SocialOnly' | 'SocialAndBlogs' | 'EmailAndBlogs';

export interface IContentNotesGenerateRequest {
	transcriptContent: string;
	accountId: string;
	businessName: string;
	websiteUrl: string;
	/** All optional on the API, which falls back to its previous behavior without them. */
	outputMix?: ContentPlanOutputMix;
	/** First month to plan, as "yyyy-MM". */
	startMonth?: string;
	monthCount?: number;
	newsletterTemplateId?: string;
}

export interface IContentNotesGenerateResponse {
	htmlContent: string;
}

export function useAdminContentNotesGenerateMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IContentNotesGenerateRequest) => {
			return userSession.webServiceHelper.callAsync<IContentNotesGenerateResponse>(
				'admin/zoom/transcripts/content-notes/generate',
				'POST',
				request
			);
		},
	});
}
